import {apiRequest} from "./apiRequest";
import type {
  PaidUpgradeDefaults,
  SubscriptionUpgradePreview,
  SubscriptionUpgradePreviewRequest,
} from "@calendall/shared";

export async function getPaidUpgradeDefaults(): Promise<PaidUpgradeDefaults> {
  return apiRequest<PaidUpgradeDefaults>({path: "admin/configuration/paid-upgrade-defaults"});
}

export async function updatePaidUpgradeDefaults(defaults: PaidUpgradeDefaults): Promise<PaidUpgradeDefaults> {
  return apiRequest<PaidUpgradeDefaults>({
    path: "admin/configuration/paid-upgrade-defaults",
    method: "PUT",
    body: defaults,
  });
}

/** Undefined when saving the subscription changes nothing beyond the subscription itself. */
export async function previewSubscriptionUpgrade(
  tenantId: string,
  request: SubscriptionUpgradePreviewRequest,
): Promise<SubscriptionUpgradePreview | undefined> {
  return apiRequest<SubscriptionUpgradePreview | undefined>({
    path: `admin/tenants/${tenantId}/subscriptions/upgrade-preview`,
    method: "POST",
    body: request,
  });
}
